import { z } from 'zod';

export const FrontendEnvSchema = z.strictObject({
  // Must prefix with VITE_ to be injected by Vite...
  VITE_GOOGLE_CLIENT_ID: z.string().optional(),
  VITE_GOOGLE_API_KEY: z.string().optional(),
});
export type FrontendEnv = z.infer<typeof FrontendEnvSchema>;

// Define the config schema
export const ConfigSchema = FrontendEnvSchema.extend({
  STAGE: z.string(),
  PINO_LOG_LEVEL: z.enum(['info', 'debug', 'warn', 'error', 'fatal', 'silent']),
  APP_NAME: z.string(),
  AWS_ACCOUNT: z.string(),
  AWS_CLI_PROFILE: z.string().optional(),
  AWS_DOMAIN: z.string(),
  SECURITY_EMAIL: z.string().email(),
  AWS_REGIONS: z.string(),
  SLACK_CLIENT_ID: z.string(),
  SLACK_APP_ID: z.string(),
  SEGMENT_WRITE_KEY: z.string(),
  DEMO_TEAM_IDS: z.string(),
  SLACK_MONITOR_ANALYTICS_TEAM_HOOK: z.string().optional(),
  SLACK_MONITOR_ANALYTICS_HOOK: z.string(),
  SLACK_MONITOR_ERRORS_HOOK: z.string(),
  NOTION_CLIENT_ID: z.string(),
  PRO_MONTHLY_PRICE_ID: z.string(),
  PRO_YEARLY_PRICE_ID: z.string(),
  BEDROCK_KB_ID: z.string().min(1),
  BEDROCK_DATA_SOURCE_ID: z.string().min(1),
}); // Allow additional properties

export type Config = z.infer<typeof ConfigSchema>;

export const LambdaEnvSchema = ConfigSchema.extend({
  DB_TABLE_NAME: z.string(),
  SQS_QUEUE_URL: z.string(),
  SQS_QUEUE_ARN: z.string(),
  SCHEDULE_ROLE_ARN: z.string(),
  KMS_KEY_ID: z.string(),
  BEDROCK_KB_BUCKET: z.string().min(1),
});

export type LambdaEnv = z.infer<typeof LambdaEnvSchema>;
